// util to get the append the new filter values to current values in session storage
// and return updated values
export const saveSearchFilterValue = (newValue: any, validateValues?: any) => {
  const currentValues = sessionStorage.getItem('searchFilter')
  const parsedCurrentValues = currentValues !== null && JSON.parse(currentValues)

  const updatedValues = validateValues ? {
    ...parsedCurrentValues,
    ...validateValues(newValue)
  } : {
    ...parsedCurrentValues,
    ...newValue
  }

  sessionStorage.setItem('searchFilter',  JSON.stringify(updatedValues))
  return updatedValues
}

// util to get the values stored in the session storage used for search and filtering
export const getSearchFilterValues = (validateValues?: any) => {
  const searchFilterValues = sessionStorage.getItem('searchFilter')

  if (searchFilterValues !== null) {
    const parsedValues = JSON.parse(searchFilterValues)

    return validateValues ? validateValues(parsedValues) : parsedValues
  }

  return
}
